import { render } from "./Allntegrations.vue?vue&type=template&id=86cd020c&scoped=true"
import script from "./Allntegrations.vue?vue&type=script&lang=js"
export * from "./Allntegrations.vue?vue&type=script&lang=js"

import "./Allntegrations.vue?vue&type=style&index=0&id=86cd020c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86cd020c"]])

export default __exports__